

































































































































































import {
  computed,
  defineComponent,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery } from '@vue/apollo-composable';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithDivideDelivery from '@/components/DeliveryNote/CommonModalWithDivideDelivery.vue';
import CommonModalWithDriverAbsenceEditor from '@/components/Driver/CommonModalWithDriverAbsenceEditor.vue';
import ViewDeliveryMarkerModal from '@/components/Delivery/ViewDeliveryMarkerModal.vue';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';
import ResourceSelectorInput from '@/components/DeliveryNote/ResourceSelectorInput.vue';
import CreateDeliveryNoteStats from '@/components/DeliveryNote/CreateDeliveryNoteStats.vue';
import WeightDisplay from '@/components/DeliveryNote/WeightDisplay.vue';
import AreaCode from '@/components/DeliveryNote/AreaCode.vue';
import LongDeliveryObject from '@/components/DeliveryNote/LongDeliveryObject.vue';
import Paginator from '@/components/Vivat/Paginator.vue';
import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';
import LeasedVehicleObject from '@/components/DeliveryNote/LeasedVehicleObject.vue';

import createDeliveryNote from '@/gql/deliveryNote/createDeliveryNote.gql';
import getLeasedVehicle from '@/gql/vehicle/getLeasedVehicle.gql';

import useCreateSingleDeliveryNote from '@/views/DeliveryNote/useCreateSingleDeliveryNote';
import useCreateMultiDeliveryNote, { getDeliveryNoteInformation } from '@/views/DeliveryNote/useCreateDeliveryNote';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import type { Delivery } from '@/useDelivery';
import type { DeliveryNote } from '@/useDeliveryNote';
import type { Vehicle } from '@/useVehicle';
import useAuth from '@/useAuth';
import useDelivery from '@/useDelivery';
import { BASE_DELIVERY_NOTE } from '@/useDeliveryNote';
import { DEFAULT_PAGINATOR_INFO } from '@/types/paginatorInfo';

const NOW = useFormat.date().computerShortDate();
const { sumPackagesPrice } = useDelivery();

const CreateOrder = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonModalWithDivideDelivery,
    CommonModalWithDriverAbsenceEditor,
    ViewDeliveryMarkerModal,
    CommonAreaCodeSelector,
    ResourceSelectorInput,
    WeightDisplay,
    CreateDeliveryNoteStats,
    AreaCode,
    LongDeliveryObject,
    Paginator,
    CommonDeliveryStatusSelect,
    LeasedVehicleObject,
  },
  setup() {
    const { route } = useRouter();
    const forceRender = ref(true);

    const deliveryDate = ref(NOW);
    const toCurrency = (number: string) => useFormat.number(number).currency();
    const displayDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const toDecimalFormat = (string: any, min = 0, max = 0) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });
    const { translateDistanceType } = useDeliveryAreaCode();
    const useCreateDeliveryNote = useCreateSingleDeliveryNote();
    const { me } = useAuth();
    const {
      sortDeliveryDisplay,
      sortDeliveryList,
      vehicles,
    } = useCreateMultiDeliveryNote();

    const hubs = computed(() => me.company.hubs || []);

    const deliveryNotes: Ref<DeliveryNote[]> = ref([]);
    const selectedDeliveries: Ref<Delivery[]> = ref([]);
    const selectedDeliveriesId: Ref<number[]> = ref([]);
    function selectDelivery(d: Delivery) {
      const idx = selectedDeliveriesId.value.indexOf(parseInt(d.id as string, 10));
      if (idx > -1) {
        selectedDeliveries.value.splice(idx, 1);
        selectedDeliveriesId.value.splice(idx, 1);
      } else {
        selectedDeliveriesId.value.push(parseInt(d.id as string, 10));
        selectedDeliveries.value.push(d);
      }
    }

    const { result: leasedVehicleResult, loading: leasedVehicleLoading } = useQuery(getLeasedVehicle, computed(() => {
      const OR = [];
      if (useCreateDeliveryNote.filter.deliverySearch !== '') {
        OR.push({
          OR: [
            { column: 'CONTACT_NAME', operator: 'LIKE', value: `%${useCreateDeliveryNote.filter.deliverySearch}%` },
            { column: 'ORDER_NUMBER', operator: 'LIKE', value: `%${useCreateDeliveryNote.filter.deliverySearch}%` },
            { column: 'CUSTOMER_NAME', operator: 'LIKE', value: `%${useCreateDeliveryNote.filter.deliverySearch}%` },
          ],
        });
      }

      return {
        id: useCreateDeliveryNote.filter.reservedVehicleId,
        // filter: {
        //   OR,
        // },
      };
    }), () => ({
      enabled: useCreateDeliveryNote.filter.reservedVehicleId !== undefined && useCreateDeliveryNote.filter.reservedVehicleId !== -1,
      fetchPolicy: 'network-only',
    }));
    const allDeliveriesPaginatorInfo = computed(() => leasedVehicleResult.value?.vehicle.leasedDeliveries?.paginatorInfo || { ...DEFAULT_PAGINATOR_INFO });
    const allDeliveries: Ref<any> = ref([]);
    watch(() => leasedVehicleResult.value, (newVal, oldVal) => {
      if (newVal !== oldVal && !leasedVehicleLoading.value) {
        selectedDeliveries.value = [];
        selectedDeliveriesId.value = [];
        allDeliveries.value = newVal?.vehicle.leasedDeliveries?.data.map((delivery: any) => ({
          ...delivery,
          packagesPrice: sumPackagesPrice(delivery.packages),
        }));
        allDeliveries.value.forEach((d: Delivery) => {
          selectedDeliveries.value.push(d);
          selectedDeliveriesId.value.push(parseInt(d.id as string, 10));
        });
      }
    });
    function leasedMoveDelivery(index: number, direction = 1) {
      const mainId = allDeliveries.value[index];
      const newPositionId = allDeliveries.value[index + direction];
      const mainIndex = selectedDeliveries.value.indexOf(mainId);
      const newPositionIndex = selectedDeliveries.value.indexOf(newPositionId);
      if (mainIndex > -1 && newPositionIndex > -1) {
        /* eslint-disable */
        selectedDeliveries.value[index + direction] = selectedDeliveries.value.splice(index, 1, selectedDeliveries.value[index + direction])[0];
        selectedDeliveriesId.value[index + direction] = selectedDeliveriesId.value.splice(index, 1, selectedDeliveriesId.value[index + direction])[0];
      }
      allDeliveries.value[index + direction] = allDeliveries.value.splice(index, 1, allDeliveries.value[index + direction])[0];
      /* eslint-enable */
    }

    const deliveryNote: Ref<DeliveryNote> = ref({ ...BASE_DELIVERY_NOTE });
    const vehicleType = computed(() => deliveryNote.value.vehicle?.vehicleType || leasedVehicleResult.value?.vehicle.vehicleType || undefined);
    function selectReservedVehicle(vehicle: Vehicle) {
      useCreateDeliveryNote.filter.reservedVehicleId = vehicle.id as any;
    }

    const deliveryNoteInformation = computed(() => getDeliveryNoteInformation(selectedDeliveries.value));

    // Use to toggle Vehicle Selector modal
    const driverSelectorModal = ref(null);
    const vehicleSelectorModal = ref(null);
    function pendingSelectDriver() {
      (driverSelectorModal.value as any).open();
    }
    function setDriverOnVehicle(driver: any) {
      deliveryNote.value.driver = driver;
    }
    function pendingSelectVehicle() {
      (vehicleSelectorModal.value as any).open();
    }
    function setVehicleOnDeliveryNote(vehicle: any) {
      deliveryNote.value.vehicle = vehicle;
      if (!(deliveryNote.value.driver) && (deliveryNote.value.driver as any)?.id !== -1) {
        deliveryNote.value.driver = { ...vehicle.defaultDriver };
      }
    }

    // Use to compare vehicle type with estimate delivery fee
    const computedVehicleTypeDeliveryCost = computed(() => {
      switch (vehicleType.value as any) {
        case 'PICKUP':
          return deliveryNoteInformation.value?.pickupLeasedFee;
        case 'SIX_WHEELS':
          return deliveryNoteInformation.value?.sixWheelLeasedFee;
        case 'TEN_WHEELS':
          return deliveryNoteInformation.value?.tenWheelLeasedFee;
        case 'TRAILER':
          return deliveryNoteInformation.value?.trailerLeasedFee;
        default:
          return 0;
      }
    });

    const refetchQueries = [
      'countDeliveryNote', 'getDeliveryNotes', 'getDeliveries', 'getVehicles', 'getLeasedVehicles', 'getLeasedVehicle', 'getDeliveryNotesForArrange', 'getDeliveryNote', 'getMostStableTotalItem', 'countDeliveryGroups', 'countDeliveryNoteStatus',
    ];
    const createDeliveryNoteInput = computed(() => ({
      // status: deliveryNote.status,
      status: deliveryNoteInformation.value?.status || deliveryNote.value.status,
      driver: { connect: parseInt((deliveryNote.value.driver as any)?.id, 10) },
      vehicle: { connect: parseInt((deliveryNote.value.vehicle as any)?.id, 10) },
      deliveries: {
        update: selectedDeliveries.value
          .map((delivery: Delivery, index: number) => ({
            id: parseInt(delivery.id as string, 10),
            order: index + 1,
            reservedVehicle: { disconnect: true },
          })),
      },
      deliveryManCount: deliveryNote.value.deliveryManCount,
      distanceType: deliveryNoteInformation.value.distance || 'NA',
      deliveryDate: deliveryDate.value,
      area: deliveryNoteInformation.value?.area?.id ? { connect: deliveryNoteInformation.value.area?.id } : undefined,
      type: route.value.params.id ? undefined : 'LEASED',
      estimateDeliveryFee: computedVehicleTypeDeliveryCost.value,
    }));
    const createDeliveryNoteMutation = useMutation(createDeliveryNote, () => ({
      variables: {
        input: createDeliveryNoteInput.value,
      },
      refetchQueries,
    }));
    function pendingToSave() {
      createDeliveryNoteMutation.mutate();
    }

    const successCreateDeliveryNoteModal = ref(null);
    const errorCreateDeliveryNoteModal = ref(null);
    createDeliveryNoteMutation.onDone((result: any) => {
      deliveryNote.value.id = result.data.createDeliveryNote.id;
      deliveryNote.value.uniqueId = result.data.createDeliveryNote.uniqueId;
      (successCreateDeliveryNoteModal.value as any).compose({ action: 'สร้าง', entity: 'รายการ สำเร็จ' });
    });
    function mutationErrorHandler(mutationResponse: any) {
      let message = '';
      let entity = 'คนขับ';
      const responseMessage = mutationResponse.message;
      if (responseMessage === 'DRIVER' || responseMessage === 'LOADER') {
        switch (responseMessage) {
          case 'LOADER':
            entity = 'พนักงานยกของ';
            break;
          default:
            entity = 'คนขับ';
        }
        message = `โปรดตรวจเช็คค่าตอบแทน${entity} ให้ตรงกับรายการที่ท่านสร้าง`;
      }
      (errorCreateDeliveryNoteModal.value as any).compose({ body: message });
    }
    createDeliveryNoteMutation.onError((res: any) => {
      mutationErrorHandler(res);
    });

    // Divide Delivery stuff
    const pendingDivideDelivery: Ref<number> = ref(-1);
    const divideDeliveryModal = ref(null);
    function openDivideDeliveryModal($event: number) {
      pendingDivideDelivery.value = $event;
      (divideDeliveryModal.value as any).open();
    }

    // Use to render map modal
    const viewMapModal = ref(null);
    const mapMarkers: Ref<{ delivery: any; lat: number; lng: number; open: boolean }[]> = ref([]);
    function pendingToViewMap() {
      const positionsLat: any[] = [];
      const positionsLong: any[] = [];
      mapMarkers.value = selectedDeliveries.value.filter((dv: any) => {
        const latIndex = positionsLat.indexOf(dv.computedLatLong.lat);
        const longIndex = positionsLong.indexOf(dv.computedLatLong.long);
        if ((latIndex !== -1 && (positionsLong.length > latIndex && positionsLong[latIndex] === dv.computedLatLong.long))
          || (longIndex !== -1 && (positionsLat.length > longIndex && positionsLat[longIndex] === dv.computedLatLong.lat))
        ) return undefined;
        positionsLat.push(dv.computedLatLong.lat);
        positionsLong.push(dv.computedLatLong.long);
        return dv;
      }).map((dv: any) => ({
        delivery: dv,
        open: false,
        lat: parseFloat(dv.computedLatLong.lat) >= -90 && parseFloat(dv.computedLatLong.lat) <= 90 ? parseFloat(dv.computedLatLong.lat) : 0,
        lng: parseFloat(dv.computedLatLong.long) >= -180 && parseFloat(dv.computedLatLong.long) <= 180 ? parseFloat(dv.computedLatLong.long) : 0,
      }));
      (viewMapModal.value as any).open();
    }

    return {
      toCurrency,
      toDecimalFormat,
      displayDate,
      translateDistanceType,
      forceRender,
      deliveryDate,

      selectReservedVehicle,
      leasedMoveDelivery,

      me,
      hubs,

      vehicles,
      vehicleType,
      computedVehicleTypeDeliveryCost,

      allDeliveries,
      allDeliveriesPaginatorInfo,
      ...useCreateDeliveryNote,

      deliveryNote,
      deliveryNotes,
      createDeliveryNote,
      createDeliveryNoteMutation,
      sortDeliveryDisplay,
      sortDeliveryList,

      createDeliveryNoteInput,

      successCreateDeliveryNoteModal,
      errorCreateDeliveryNoteModal,

      deliveryNoteInformation,

      driverSelectorModal,
      pendingSelectDriver,
      setDriverOnVehicle,
      vehicleSelectorModal,
      pendingSelectVehicle,
      setVehicleOnDeliveryNote,

      pendingToSave,

      divideDeliveryModal,
      pendingDivideDelivery,
      openDivideDeliveryModal,

      // use to view map on each DeliveryNote
      viewMapModal,
      mapMarkers,
      pendingToViewMap,

      selectDelivery,
      selectedDeliveries,
      selectedDeliveriesId,
    };
  },
});

export default CreateOrder;
